import { ConstructionAmountResult } from "../types";

export default function validateResult({
  amount,
  dimensions,
  error,
  weight,
}: ConstructionAmountResult): ConstructionAmountResult {
  return {
    amount: amount === Infinity ? 0 : amount,
    dimensions: {
      length: dimensions.length === Infinity ? 0 : dimensions.length,
      height: dimensions.height === Infinity ? 0 : dimensions.height,
      thickness: dimensions.thickness === Infinity ? 0 : dimensions.thickness,
    },
    weight: weight === Infinity ? 0 : weight,
    error,
  };
}
